import React from "react";
import MainPageDialog from "../../components/mainPageDialog";
import { AppListing } from "../../components/appListing";
import moment from "moment";
import { demographicsApi } from "../../redux/service/demographic_services";
import { toast } from "react-toastify";

const AmendmentRequestUpPop = ({ previewData, setPreviewData ,refetchDemographics}) => {
  const [cancelAmendment] =
  demographicsApi.endpoints.cancelAmendment.useLazyQuery();
  const cols = [
    { title: "Title", key: "title" },
    { title: "Current Value", key: "current_value",getData:(data)=>!Array.isArray(data?.current_value) && data?.current_value },
    { title: "Requested Value", key: "new_value" },
  ];
  return (
    <>
      {previewData?.amendments && (
        <MainPageDialog
          title="Request Details"
          modalSize="md"
          maxHeight={true}
          onCancelHandler={() => setPreviewData(null)}
          footerList={[
            {
              title: "Close",
              type: "close",
              action: () => setPreviewData(null),
            },
            previewData?.cancelRequest && {
              title: "Yes",
              type: "save",
              action: () => {
                cancelAmendment({id:previewData?.id}).then((res)=>{
                  if (res?.data?.code==0){
                    toast.success(res?.data?.msg)
                    refetchDemographics()
                    setPreviewData(null)
                  }
                  else{
                    toast.error(res?.data?.msg)

                  }
                })
              }
            }
          ]}
        >
          {previewData?.cancelRequest && (
            <p className="text-lg">
              Are you sure you want to cancel this request?
            </p>
          )}
          <div className="flex justify-between items-center flex-wrap sm:flex-nowrap px-3 py-3 sm:px-4 bg-green-500 rounded-t-lg text-white">
            <h3 className="text-lg font-bold tracking-wide leading-6">
              Amendment Request
            </h3>
            <p className="text-base font-bold tracking-wider">
              Date :{" "}
              <span className="font-medium">
                {previewData?.created
                  ? moment(previewData?.created).format("MM/DD/YYYY hh:mm A")
                  : "N/A"}
              </span>
            </p>
          </div>
          <div className="mt-3">
            <AppListing cols={cols} listData={previewData?.amendments || []} />
          </div>
        </MainPageDialog>
      )}
    </>
  );
};

export default AmendmentRequestUpPop;
